<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'UpLevelDayStat',
  props: {
    title: {
      type: String,
      default: '活跃玩家关卡区间分布曲线'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(data) {
      this.initChart()
      const time = []
      const upLevelData = {}
      const types = {
        lv1: '1-5',
        lv2: '6-10',
        lv3: '11-20',
        lv4: '21-30',
        lv5: '31-40',
        lv6: '41-50',
        lv7: '51-60',
        lv8: '61-70',
        lv9: '71-80',
        lv10: '81-90',
        lv11: '91-100',
        lv12: '100+'
      }
      for (let k = 1; k <= 12; k++) {
        const keyText = 'lv' + k
        upLevelData[keyText] = []
      }
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(data[i].date))
        for (const k in val.data) {
          if (k.indexOf('lv') !== -1) {
            upLevelData[k].push(val.data[k])
          }
        }
      }
      for (const i in upLevelData) {
        const val = upLevelData[i]
        this.option.legend.data.push(types[i])
        const temp = {
          name: types[i],
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        }
        this.option.series.push(temp)
      }
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    },
    refresh2(data) {
      this.initChart()
      const time = []
      const typeArr = { 'new_user': '新用户', 'act_user': '活跃用户' }
      const upLevelData = { 'new_user': [], 'act_user': [] }
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(data[i].date))
        for (const k in val.data) {
          upLevelData[k].push(val.data[k])
        }
      }
      for (const i in upLevelData) {
        const val = upLevelData[i]
        const title = typeArr[i]
        this.option.legend.data.push(title)
        const temp = {
          name: title,
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        }
        this.option.series.push(temp)
      }
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
